import React, { useEffect, useState } from 'react'
import '../static/style/project.css'
import GitHubIcon from '@mui/icons-material/GitHub';
import LaunchIcon from '@mui/icons-material/Launch';
import {db} from '../firbase-conf'
import {collection, getDocs} from "firebase/firestore"
function Projects() {
    const [projects , setProjects] = useState([])
    const projectsCollectionRsf = collection(db ,"projects")

    useEffect(() =>{
        const getProjects = async()=>{
            const data = await getDocs(projectsCollectionRsf)
            setProjects(data.docs.map((doc)=>({...doc.data(), id:doc.id})))
        }

        getProjects()
    },[])
    return (
        <div className='project__content'>
            <div className='head'>
                <h2>Some Things I’ve Built</h2>
            </div>
            <div className='projects'>
                {projects?.map((project)=>{
                    return(
                        <div className='project'>
                            <img src={project.link} loading="lazy"/>
                            <div className='content'>
                                <div className='featured'>Featured Project</div>
                                <div className='title'>{project.title}</div>
                                <div className='description'>{project.description}</div>
                                <div className='tools'>
                                    {project.tools?.map((tool)=>{
                                        return(
                                            <p>{tool}</p>
                                        )
                                    })}
                                </div>
                                <div className='links'>
                                    <a href={project.github_link}><GitHubIcon/> </a>
                                    <a href={project.direct_link}><LaunchIcon/> </a>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Projects